import React from "react";
import {
  LoginIcon,
  LogoutIcon,
  CoffeeIcon,
  PlayIcon,
  ClockIcon,
} from "../../Icons";

const ActivityLog = ({ logs = [] }) => {
  const getActivityConfig = (title) => {
    const t = title?.toLowerCase() || "";
    if (t.includes("clock in"))
      return {
        icon: LoginIcon,
        color: "text-emerald-600",
        bg: "bg-emerald-50",
        border: "border-emerald-100",
      };
    if (t.includes("clock out"))
      return {
        icon: LogoutIcon,
        color: "text-rose-600",
        bg: "bg-rose-50",
        border: "border-rose-100",
      };
    if (t.includes("break in") || t.includes("break start"))
      return {
        icon: CoffeeIcon,
        color: "text-amber-600",
        bg: "bg-amber-50",
        border: "border-amber-100",
      };
    if (
      t.includes("break out") ||
      t.includes("break end") ||
      t.includes("resume")
    )
      return {
        icon: PlayIcon,
        color: "text-indigo-600",
        bg: "bg-indigo-50",
        border: "border-indigo-100",
      };
    return {
      icon: ClockIcon,
      color: "text-gray-600",
      bg: "bg-gray-50",
      border: "border-gray-100",
    };
  };

  return (
    <div className="bg-white rounded-xl p-5 shadow-sm border border-indigo-200 h-full flex flex-col font-sans">
      <div className="flex items-center justify-between mb-5 shrink-0">
        <h3 className="text-indigo-800 font-bold text-base tracking-tight flex items-center gap-3">
          <div className="w-1 h-5 bg-indigo-300 rounded-full" />
          Activity Log
        </h3>
        <span className="text-xs font-medium text-indigo-700 bg-indigo-50 px-2.5 py-1 rounded-md border border-indigo-100">
          Today
        </span>
      </div>

      <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar space-y-3">
        {logs.length === 0 && (
          <div className="flex flex-col items-center justify-center h-40 text-center">
            <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center mb-3">
              <ClockIcon size={24} className="text-gray-400" />
            </div>
            <p className="text-gray-500 font-medium text-sm">
              No activity recorded
            </p>
          </div>
        )}

        {logs.map((activity, index) => {
          const config = getActivityConfig(activity.title);
          const Icon = config.icon;

          return (
            <div
              key={index}
              className={`flex items-center gap-4 p-4 rounded-xl border transition-all duration-200 hover:shadow-sm ${config.bg} ${config.border} bg-opacity-40`}
            >
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center bg-white shadow-sm shrink-0 ${config.color}`}
              >
                <Icon size={18} strokeWidth={2.5} />
              </div>

              <div className="flex-1 min-w-0">
                <h4 className={`text-sm font-bold ${config.color} truncate`}>
                  {activity.title}
                </h4>
                {activity.notes && (
                  <p className="text-xs text-gray-500 truncate mt-0.5">
                    {activity.notes}
                  </p>
                )}
              </div>

              <div className="text-right shrink-0">
                <span className="block text-sm font-bold text-gray-700">
                  {activity.time}
                </span>
                <span className="text-[10px] text-gray-400 font-medium uppercase tracking-wide">
                  {activity.time.includes("AM") ? "Morning" : "Afternoon"}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityLog;
